import { useState } from 'react';

const testimonials = [
  {
    quote:
      'A melhor CSSBuy spreadsheet que já usei. Produtos atualizados todos os dias, links diretos e guias que realmente funcionam para importação no Brasil.',
    name: 'Lucas Oliveira',
    role: 'Comprador frequente • São Paulo',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20brazilian%20man%20warm%20lighting%20clean%20cream%20background%20friendly%20expression%20modern%20editorial%20style%20simple%20composition&width=120&height=120&seq=avatar-testimonial-05&orientation=squarish',
  },
  {
    quote:
      'Uso a planilha toda semana para encontrar produtos novos. A curadoria é excelente e os links sempre funcionam. Recomendo para todo mundo que compra no CSSBuy.',
    name: 'Marina Santos',
    role: 'Empresária • Rio de Janeiro',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20brazilian%20woman%20warm%20lighting%20clean%20cream%20background%20friendly%20smile%20modern%20editorial%20style%20simple%20composition&width=120&height=120&seq=avatar-testimonial-06&orientation=squarish',
  },
  {
    quote:
      'Finalmente encontrei uma spreadsheet organizada e em português. As comparações entre plataformas me ajudaram a economizar muito no frete.',
    name: 'Pedro Costa',
    role: 'Estudante • Lisboa',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20portuguese%20man%20warm%20lighting%20clean%20cream%20background%20friendly%20expression%20modern%20editorial%20style%20simple%20composition&width=120&height=120&seq=avatar-testimonial-07&orientation=squarish',
  },
];

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);
  const t = testimonials[current];

  const goPrev = () => {
    setCurrent((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrent((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section id="reviews" className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="font-heading text-xl md:text-2xl italic text-foreground-400 mb-4">
            ( Reviews )
          </p>
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-foreground-950">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-star-fill text-accent-500 text-sm"></i>
            </div>
            <span className="text-sm font-semibold text-background-50">4.9/5</span>
          </div>
        </div>

        {/* Testimonial */}
        <div className="relative max-w-[720px] mx-auto">
          <div className="text-center">
            {/* Quote marks */}
            <div className="font-heading text-6xl md:text-7xl text-primary-300/30 leading-none mb-4 select-none">
              &ldquo;
            </div>

            <blockquote className="text-lg md:text-xl lg:text-2xl font-heading italic text-foreground-800 leading-relaxed mb-8">
              {t.quote}
            </blockquote>

            {/* User info */}
            <div className="inline-flex items-center gap-3">
              <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="text-left">
                <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.role}</p>
              </div>
            </div>
          </div>

          {/* Nav arrows */}
          <div className="flex items-center justify-center gap-3 mt-8">
            <button
              onClick={goPrev}
              className="w-10 h-10 flex items-center justify-center rounded-lg border border-foreground-300 text-foreground-700 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
            </button>
            <button
              onClick={goNext}
              className="w-10 h-10 flex items-center justify-center rounded-lg bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-all cursor-pointer"
            >
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-4">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrent(idx)}
                className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                  idx === current ? 'bg-primary-500 w-5' : 'bg-foreground-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}